module.exports = __webpack_public_path__ + "media/images/placeholders/jugendliche-555e62aa7dc756b88f1fe6838e203b7f.jpg";